export default defineNuxtRouteMiddleware(to => {
  const config = useRuntimeConfig()
  const { enabled } = useCareerSite()

  if (enabled.value && !to.name?.startsWith('career')) {
    return navigateTo(config.public.baseUrl, { external: true, redirectCode: 301 })
  }
})
